import { render, staticRenderFns } from "./NewsletterModal.vue?vue&type=template&id=3e8a7e50&"
import script from "./NewsletterModal.vue?vue&type=script&lang=js&"
export * from "./NewsletterModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e8a7e50')) {
      api.createRecord('3e8a7e50', component.options)
    } else {
      api.reload('3e8a7e50', component.options)
    }
    module.hot.accept("./NewsletterModal.vue?vue&type=template&id=3e8a7e50&", function () {
      api.rerender('3e8a7e50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/elements/modals/NewsletterModal.vue"
export default component.exports